import React from 'react';
import PropTypes from 'prop-types';
import './SelectedTeamEsportsRunning.css';

// Placeholder component for displaying the selected Esports team in Running state
const SelectedTeamEsportsRunning = ({ team, contest }) => {
  // TODO: Implement logic to display details of the selected Esports team
  // console.log("SelectedTeamEsportsRunning loaded for team:", team, "contest:", contest);

  // Placeholder rendering
  return (
    <div className="selected-team-container">
      <h4>Selected Esports Team: {team.entryName}</h4>
      <p>Display selected Esports team details (players, stats, scores, etc.) here.</p>
      {/* Example:
      <ul>
        {team.players?.map(player => (
          <li key={player.playerId}>{player.name} - KDA: {player.sportSpecificData?.kda || 'N/A'}</li>
        ))}
      </ul>
      */}
    </div>
  );
};

SelectedTeamEsportsRunning.propTypes = {
  team: PropTypes.object.isRequired,
  contest: PropTypes.object.isRequired,
};

export default SelectedTeamEsportsRunning; 